import {InsightsStatistics, Statistics} from "../api/types/Insights";

export const getInsightStatisticsWithoutHidden: (insightsData: InsightsStatistics | null) =>  Statistics | null = (insightsData: InsightsStatistics | null) => {
    if (!insightsData) return null;
    const hiddenRiskIndicatorsSet = insightsData.hiddenRiskIndicators ? new Set(insightsData.hiddenRiskIndicators) : new Set<string>()

    return Object.fromEntries(
        Object.entries(insightsData?.insightsStatistics || {}).filter(([key]) => !hiddenRiskIndicatorsSet.has(key))
    );
}